import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {AuthPage} from '@/modules/auth'
import Login from '@/modules/auth/components/Login'
import ForgotPassword from '@/modules/auth/components/ForgotPassword'

export function PublicRoutes() {
  return <AuthPage />
}
